import React from 'react';

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PostCallMessageDeleteDialogProps {
  open: boolean;
  position?: number;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PostCallMessageDeleteDialog: React.FC<PostCallMessageDeleteDialogProps> = ({
  open,
  position,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('campaignPage.postCallMessages.deleteTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('campaignPage.postCallMessages.deleteDescription', { position })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <CircularProgress size={20} color="inherit" /> : t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PostCallMessageDeleteDialog;
